export interface PersonIdentity {
  accountId?: number;
  avatar: string;
  fullname: string;
  lastname: string;
  firstname: string;
  username?: string;
  // the two fields below are used for searching/filtering on a person
  firstnameLastnamePair?: string;
  lastnameFirstnamePair?: string;
}

export interface Person extends Partial<PersonIdentity> {
  date_naissance?: string | Date | null;
  fullname: string;
  token: string;
  pseudo?: string;
  login?: string;
}
